module.exports = __webpack_public_path__ + "static/media/distrigo_logo.a4da304f.svg";